import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as orderStatus from "../constants/orderStatus";
import * as config from "../constants/config";
import * as handlers from "../constants/handlers";

export const selectOrder = (id) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ORDER_DETAIL,
        params: {
            id: id
        }
    },
    method: handlers.INTERGAMMA_MACHINE_ORDER_DETAIL,
    tabId: 0
});

export const deleteOrder = (order) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_ORDER_STATUS,
        params: {
            orderIdentifier: order.identifier,
            status: orderStatus.ORDER_STATUS_CANCELED
        }
    },
    method: handlers.INTERGAMMA_MACHINE_SET_CANCELED_ORDER_STATUS,
    tabId: 0
});

export const getToDispenseOrders = (sorting) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_TO_DISPENSE_GET_ORDERS,
        params: {
            offset: 0,
            orderBy: sorting,
            rowCount: config.MAX_ORDERS_LIMIT,
            statusFilter: orderStatus.TO_DISPENSE_ORDER_STATUS_LIST
        }
    },
    method: handlers.TO_DISPENSE_GET_ORDERS,
    tabId: 0
});

export const setOverrideMode = (active) => ({
    type: actionTypes.INTERGAMMA_SET_OVERRIDE_MODE,
    payload: {
        active: active
    }
});

export const setActiveDatabase = (databaseName) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_ACTIVE_DATABASE,
        params: {
            name: databaseName,
            autologin: true
        }
    },
    method: handlers.INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE,
    tabId: 0
});
